import React from 'react';
import { StepProps } from '../common';
import ItemRejection from '../../itemRejection';

function StepReject({ exit, idx, stepName, title, stepCaption, active, props }: StepProps) {
  return <ItemRejection />;
}

export default StepReject;
